import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { replaceStringValues, translate } from '../Services/translation';

const YourRoof = ({
  title,
  titleModal,
  preamble,
  defaultTypePreamble,
  text,
  handleSetRoofType,
  selectedRoofType,
  roofs,
  isDefaultRoofType,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [internalRoofType, setInternalRoofType] = useState(selectedRoofType?.id);

  const handleRoofSelected = (id) => {
    handleSetRoofType(id);
  };

  const handleCloseModal = () => {
    handleRoofSelected(internalRoofType);
    setIsModalOpen(false);
  };

  return (
    <>
      {isModalOpen && (
        <div className="your-roof-card-modal__overlay">
          <div className="your-roof-card-modal__container">
            <div className="your-roof-card-modal__title">{titleModal}</div>
            <div role="radiogroup" className="your-roof-card-modal__roof-list">
              {roofs.map((roof) => {
                return (
                  <label key={roof.id}>
                    <input
                      type="radio"
                      name="variant"
                      defaultChecked={roof.id === selectedRoofType.id}
                      className="your-roof-card-modal-input"
                      onClick={() => setInternalRoofType(roof.id)}
                    />
                    <div className="your-roof-card-modal-roof-card" key={roof.id}>
                      <div className="your-roof-card-modal__roof-card-image-wrapper">
                        <img
                          src={roof.imgsrc}
                          alt=""
                          className="your-roof-card-modal__roof-card-image"
                        />
                      </div>
                      <div className="your-roof-card-modal-roof-card-title">
                        {roof.name}
                      </div>
                    </div>
                  </label>
                );
              })}
            </div>
            <div className="your-roof-card-modal__bottom-container">
              <button
                className="your-roof-card-modal__close"
                onClick={() => handleCloseModal()}
              >
                {translate('solcellepanel.general.close')}
              </button>
            </div>
          </div>
        </div>
      )}
      <section className="your-roof-card">
        <div className="your-roof-card__title">
          {title + ' ' + selectedRoofType.name}
        </div>
        <div className="your-roof-card__container">
          <div>
            <div className="your-roof-card__image-wrapper">
              <img
                className="your-roof-card__image"
                src={selectedRoofType.imgsrc}
                alt=""
              />
            </div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="your-roof-card__change"
            >
              {translate('solcellepanel.general.changeroof')}
            </button>
          </div>
          <div className="your-roof-card__text-content">
            <div className="your-roof-card__preamble">
              {replaceStringValues(
                isDefaultRoofType ? defaultTypePreamble : preamble,
                {
                  roofType: selectedRoofType.name,
                }
              )}
            </div>
            <div className="your-roof-card__text">{text}</div>
          </div>
        </div>
      </section>
    </>
  );
};

export default YourRoof;

YourRoof.propTypes = {
  title: PropTypes.string,
  titleModal: PropTypes.string,
  preamble: PropTypes.string,
  defaultTypePreamble: PropTypes.string,
  text: PropTypes.string,
  handleSetRoofType: PropTypes.func,
  selectedRoofType: PropTypes.object,
  roofs: PropTypes.array,
  isDefaultRoofType: PropTypes.bool,
};
